import React from 'react';
import './css/index.scss';
import { useSelector } from 'react-redux';
import TableCell from '../../../../components/TableCell';
import CloseIcon from '../../../../assets/formIcons/close.svg';
import RefreshIcon from '../../../../assets/formIcons/refresh.svg';
import TableRow from '../../../../components/TableRow';
import { USER_MODAL_STATES } from '../../constants';
import avatarIcon from '../../../../assets/formIcons/avatar.svg';
import DotsIcon from '../../../../assets/formIcons/dots.svg';
import useComponentVisible from '../../../../helpers/hooks/useComponentVisible';
import { ORGANIZATION_MODAL_STATES } from '../../../Organizations/constants';
import BlockIcon from '../../../../assets/formIcons/block.svg';
import ChangeOrgIcon from '../../../../assets/formIcons/changeOrg.svg';
import ChangePhotosIcon from '../../../../assets/formIcons/photosSmall.svg';
import ChangeUserIcon from '../../../../assets/formIcons/changeUser.svg';
import DeleteIcon from '../../../../assets/formIcons/delete.svg';

function UserItem({
  item, itemsPassed, widths, index, setSelectedUser, setModalState, setIsModalVisible,
}) {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { profile } = useSelector((store) => store.account);

  const onPopupItemClick = (state) => () => {
    setSelectedUser(item);
    setModalState(state);
    setIsModalVisible(true);
    setIsComponentVisible(false);
  };

  return (
    <TableRow key={item._id} dashed={!item.is_active}>
      <TableCell width={widths[0]}>
        <div className="user_item_index">
          {itemsPassed + index + 1}
          <img src={avatarIcon} alt="Avatar" />
        </div>
      </TableCell>
      <TableCell width={widths[1]}>
        {item.display_name}
        {item.display_name === 'Unnamed User' ? ' (не удалять!)' : ''}
      </TableCell>
      <TableCell width={widths[2]}>{item._id}</TableCell>
      <TableCell width={widths[3]}>{item.email}</TableCell>
      <TableCell
        width={widths[4]}
        isIcon
        onClick={() => setIsComponentVisible(true)}
      >
        <img src={DotsIcon} alt="" />
      </TableCell>

      {/* <TableCell
        width={widths[4]}
        isIcon
        onClick={onPopupItemClick(item.is_active ? USER_MODAL_STATES.block : USER_MODAL_STATES.makeActive)}
      >
        {item.is_active ? (
          <img src={CloseIcon} alt="" />
        ) : (
          <img src={RefreshIcon} alt="" />
        )}
      </TableCell> */}

      <div ref={ref} className={`table_popup ${isComponentVisible && 'visible'}`}>
        {profile?.access_codes?.includes('modifyUsersAndOrgs')
          ? item.is_active ? (
            <div className="table_popup_item" onClick={onPopupItemClick(USER_MODAL_STATES.block)}>
              <img src={BlockIcon} alt="" />
              <p>Забанить пользователя</p>
            </div>
          ) : (
            <div
              className="table_popup_item"
              onClick={onPopupItemClick(USER_MODAL_STATES.makeActive)}
            >
              <img src={RefreshIcon} alt="" />
              <p>Разбанить пользователя</p>
            </div>
          ) : null}

        {profile?.access_codes?.includes('canFullyDelete') && (
          <div className="table_popup_item" onClick={onPopupItemClick(USER_MODAL_STATES.fullyDelete)}>
            <img src={DeleteIcon} alt="" />
            <p>Удалить полностью</p>
          </div>
        )}
      </div>

    </TableRow>
  );
}

export default UserItem;
